import Layout from '../views/layout/Layout'
import layoutAuth from '../views/layout/Auth'
import login from '../views/auth/login'

import home from '../views/Home';
import map from '../views/pages/map'
import company from '../views/pages/client/company'
import customer from '../views/pages/client/customer'
import card from '../views/pages/client/cards'
import cardDetails from '../views/pages/client/cardDetails'
import car from '../views/pages/client/cars'
import carDetails from '../views/pages/client/carDetails'
import zone from '../views/pages/zones'
import zoneDetails from '../views/pages/zoneDetails'
import deviceDetails from '../views/pages/deviceDetails'
import companyDetails from '../views/pages/client/companyDetails'
import customerDetails from '../views/pages/client/customerDetails'

import abonements from '../views/pages/abonements'
import parkingCards from '../views/pages/parkingCards'
import control from '../views/pages/control'

import events from '../views/pages/events'

import guests from '../views/pages/guests'
import discounts from '../views/pages/discounts'

import config from '../views/pages/config'
import settings from '../views/settings/settings'

import payCard from '../views/pages/pay'

import clientDashboard from '../views/pages/clientDashboard'

// Reports
import AbonementsProlongating from '../views/pages/reports/AbonementsProlongating'
import guestsReport from '../views/pages/reports/guests'
import eventsReport from '../views/pages/reports/events'
import zonesReport from '../views/pages/reports/zones'
import discountJournalReport from '../views/pages/reports/discountJournal'
import passagesEvents from '../views/pages/reports/passagesEvents'

// Public
import parkPay from '../views/public/pay'

let modules = null
if (sessionStorage.getItem('contentModules')) {
    modules = sessionStorage.getItem('contentModules').split(',')
}
if (!modules) modules = [ 'All' ]

let loginType = sessionStorage.getItem('loginType')
// 1 - operator
// 2 - arendator (andruxas)
// 3 - arendator change password
// 4 - permanent client (yahweh-support)
// 5 - permanent client change password
// 6 - публичная оплата
if (loginType) console.log('loginType:', loginType)

let routes = [
    {
        path: '/login',
        component: layoutAuth,
        hidden: true,
        noDropdown: true,
        meta: {
            requiresAuth: false
        },
        children: [{
            path: '/login',
            component: login,
            name: 'login',
            icon: 'fa fa-tachometer',
            meta: {title: 'Авторизация'}
        }]
    },
    {
        path: '/parkPay',
        component: layoutAuth,
        hidden: true,
        noDropdown: true,
        props: true,
        children: [
            {
                path: '/parkPay',
                component: parkPay,
                name: 'parkPay',
                icon: '',
                props: true,
                meta: {title: 'Оплата парковки'}
            }
        ]
    },
    {
        path: '/settings',
        component: Layout,
        hidden: true,
        noDropdown: true,
        props: true,
        children: [
            {
                path: '/settings',
                component: settings,
                name: 'settings',
                icon: 'fa fa-calendar-check-o',
                props: true,
                meta: {title: 'Настройки'}
            }]
    }
]

if (loginType === '6') {
    let routesEmpty = [
        {
            path: '/',
            component: Layout,
            hidden: false,
            noDropdown: false,
            title: 'Центр Управления',
            icon: 'icon-dashboard',
            children: [
                {path: '/', component: home, name: 'dashboard', icon: 'icon-dashboard', meta: {title: 'Устройства'}},
                {
                    path: '/zones',
                    component: zone,
                    name: 'zone',
                    icon: 'fa fa-clone',
                    props: true,
                    meta: {title: 'Зоны'}
                },

            ]
        }
    ]

    routes = [...routes, ...routesEmpty]
}
else if (loginType === '2' || loginType === '3') {
    let discountsRoute = {
        path: '/',
        component: Layout,
        noDropdown: true,
        children: [{ path: '/', component: discounts, name: 'discounts', icon: 'fa fa-adjust', props: true, meta: { title: 'Скидки' } }]
    }
    let guestsRoute = {
        path: '/guests',
        component: Layout,
        noDropdown: true,
        children: [{ path: '/guests', component: guests, name: 'guests', icon: 'fa fa-users', props: true, meta: { title: 'Гости' } }]
    }
    let reportsRoute = {
        path: '/reports',
        component: Layout,
        hidden: false,
        noDropdown: false,
        title: 'Отчеты',
        icon: 'fa fa-line-chart',
        children: [
            {
                path: '/reports/guests',
                component: guestsReport,
                name: 'guestsReport',
                icon: 'fa fa-line-chart',
                props: true,
                meta: {title: 'Отчет по гостям'}
            },
            {
                path: '/reports/discountJournal',
                component: discountJournalReport,
                name: 'discountJournal',
                icon: 'fa fa-line-chart',
                props: true,
                meta: {title: 'Журнал скидок'}
            }
        ]
    }
    let routesCustomer = []

    // if discount only
    if (modules.indexOf('DiscountsModule') != -1 && modules.indexOf('GuestsModule') == -1) {
        console.log('Router: discount only')
        routesCustomer.push(discountsRoute)
        routesCustomer.push(reportsRoute)
    }

    // if guests only
    else if (modules.indexOf('GuestsModule') != -1 && modules.indexOf('DiscountsModule') == -1) {
        console.log('Router: guests only')
        guestsRoute.path = guestsRoute.children[0].path = '/'
        routesCustomer.push(guestsRoute)
        routesCustomer.push(reportsRoute)
    }

    // if no modules
    else if (modules.indexOf('GuestsModule') == -1 && modules.indexOf('DiscountsModule') == -1 && modules.indexOf('All') == -1) {
        console.log('Router: no modules')
        reportsRoute.path = '/'
        routesCustomer.push(reportsRoute)
    }

    // if all
    else if (modules.indexOf('GuestsModule') != -1 || modules.indexOf('DiscountsModule') != -1 || modules.indexOf('All') != -1) {
        console.log('Router: all modules')
        routesCustomer.push(discountsRoute)
        routesCustomer.push(guestsRoute)
        routesCustomer.push(reportsRoute)
    }

    routes = [...routes, ...routesCustomer]
}
else if (loginType === '4' || loginType === '5') {
    let routesPermClient = [
        {
            path: '/',
            component: Layout,
            hidden: false,
            noDropdown: true,
            props: true,
            children: [
                { path: '/', component: clientDashboard, name: 'clientDashboard', icon: 'icon-dashboard', props: true, meta: { title: 'Личный кабинет' } }]
        },
        {
            path: '/pay',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [
                { path: '/pay', component: payCard, name: 'payCard', icon: 'fa fa-credit-card', props: true, meta: { title: 'Оплата по карте' } }]
        },
        {
            path: '/companies',
            component: Layout,
            hidden: true,
            noDropdown: false,
            props: true,
            title: 'Клиент',
            icon: 'fa fa-briefcase',
            children: [
                {
                    path: '/cards',
                    component: card,
                    name: 'card',
                    icon: 'fa fa-id-card',
                    props: true,
                    meta: {title: 'Карты'}
                },
                {
                    path: '/cars',
                    component: car,
                    name: 'car',
                    icon: 'fa fa-car',
                    props: true,
                    meta: {title: 'Автомобили'}
                }
            ]
        },
        {
            path: '/cards',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/cards/:id/details',
                    component: cardDetails,
                    name: 'cardDetails',
                    icon: 'fa fa-id-card',
                    props: true,
                    meta: {title: 'Карты'}
                }]
        },
        {
            path: '/cars',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/cars/:id/details',
                    component: carDetails,
                    name: 'carDetails',
                    icon: 'fa fa-car',
                    props: true,
                    meta: {title: 'Автомобили'}
                }
            ]
        },
        {
            path: '/reports',
            component: Layout,
            hidden: true,
            noDropdown: false,
            props: true,
            title: 'Отчеты',
            icon: 'fa fa-line-chart',
            children: [
                {
                    path: '/reports/abonements',
                    component: AbonementsProlongating,
                    name: 'AbonementsProlongating',
                    icon: 'fa fa-line-chart',
                    props: true,
                    meta: {title: 'Продление абонементов'}
                }
                // {
                //     path: '/reports/passagesEvents',
                //     component: passagesEvents,
                //     name: 'passagesEvents',
                //     icon: 'fa fa-line-chart',
                //     props: true,
                //     meta: {title: 'События проездов'}
                // }
            ]
        }
    ]

    routes = [...routes, ...routesPermClient]
}
else {
    let routesAdmin = [
        {
            path: '/',
            component: Layout,
            hidden: false,
            noDropdown: false,
            title: 'Центр Управления',
            icon: 'icon-dashboard',
            children: [
                {path: '/', component: home, name: 'dashboard', icon: 'icon-dashboard', meta: {title: 'Устройства'}},
                {
                    path: '/zones',
                    component: zone,
                    name: 'zone',
                    icon: 'fa fa-clone',
                    props: true,
                    meta: {title: 'Зоны'}
                },

            ]
        },
        {
            path: '/map',
            component: Layout,
            // hidden: (sessionStorage.getItem('parkings') ? false : true),
            hidden: true,
            noDropdown: true,
            title: 'Карта парковок',
            icon: 'icon-location-point',
            children: [
                { path: '/map', component: map, name: 'map', icon: 'icon-location-point', meta: {title: 'Карта парковок'}},
            ]
        },
        {
            path: '/companies',
            component: Layout,
            hidden: false,
            noDropdown: false,
            props: true,
            title: 'Клиент',
            icon: 'fa fa-briefcase',
            children: [
                {
                    path: '/companies',
                    component: company,
                    name: 'company',
                    icon: 'fa fa-briefcase',
                    props: true,
                    meta: {title: 'Организации'}
                },
                {
                    path: '/customers',
                    component: customer,
                    name: 'customer',
                    icon: 'fa fa-user',
                    props: true,
                    meta: {title: 'Клиенты'}
                },
                {
                    path: '/cards',
                    component: card,
                    name: 'card',
                    icon: 'fa fa-id-card',
                    props: true,
                    meta: {title: 'Карты'}
                },
                {
                    path: '/cars',
                    component: car,
                    name: 'car',
                    icon: 'fa fa-car',
                    props: true,
                    meta: {title: 'Автомобили'}
                }
            ]
        },
        {
            path: '/reports',
            component: Layout,
            hidden: false,
            noDropdown: false,
            props: true,
            title: 'Отчеты',
            icon: 'fa fa-line-chart',
            children: [
                {
                    path: '/reports/abonements',
                    component: AbonementsProlongating,
                    name: 'AbonementsProlongating',
                    icon: 'fa fa-line-chart',
                    props: true,
                    meta: {title: 'Продление абонементов'}
                },
                {
                    path: '/reports/guests',
                    component: guestsReport,
                    name: 'guestsReport',
                    icon: 'fa fa-line-chart',
                    props: true,
                    meta: {title: 'Отчет по гостям'}
                },
                {
                    path: '/reports/events',
                    component: eventsReport,
                    name: 'eventsReport',
                    icon: 'fa fa-line-chart',
                    props: true,
                    meta: {title: 'Журнал событий'}
                },
                {
                    path: '/reports/zones',
                    component: zonesReport,
                    name: 'zonesReport',
                    icon: 'fa fa-line-chart',
                    props: true,
                    meta: {title: 'Отчет по зонам'}
                },
                {
                    path: '/reports/discountJournal',
                    component: discountJournalReport,
                    name: 'discountJournal',
                    icon: 'fa fa-line-chart',
                    props: true,
                    meta: {title: 'Журнал скидок'}
                },
                {
                    path: '/reports/passagesEvents',
                    component: passagesEvents,
                    name: 'passagesEvents',
                    icon: 'fa fa-line-chart',
                    props: true,
                    meta: {title: 'События проездов'}
                }
            ]
        },
        {
            path: '/events',
            component: Layout,
            hidden: false,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/events',
                    component: events,
                    name: 'events',
                    icon: 'fa fa-calendar-check-o',
                    props: true,
                    meta: {title: 'События парковки'}
                }]
        },
        {
            path: '/guests',
            component: Layout,
            hidden: (modules.indexOf('GuestsModule') != -1 || modules.indexOf('All') != -1 ? false : true),
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/guests',
                    component: guests,
                    name: 'guests',
                    icon: 'fa fa-users',
                    props: true,
                    meta: {title: 'Гости'}
                }]
        },
        {
            path: '/companies',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/companies/:id/details',
                    component: companyDetails,
                    name: 'companyDetails',
                    icon: 'fa fa-briefcase',
                    props: true,
                    meta: {title: 'Организации'}
                }]
        },
        {
            path: '/customers',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/customers/:id/details',
                    component: customerDetails,
                    name: 'customerDetails',
                    icon: 'fa fa-user',
                    props: true,
                    meta: {title: 'Клиенты'}
                }]
        },
        {
            path: '/cards',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/cards/:id/details',
                    component: cardDetails,
                    name: 'cardDetails',
                    icon: 'fa fa-id-card',
                    props: true,
                    meta: {title: 'Карты'}
                }]
        },
        {
            path: '/cars',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/cars/:id/details',
                    component: carDetails,
                    name: 'carDetails',
                    icon: 'fa fa-car',
                    props: true,
                    meta: {title: 'Автомобили'}
                }
            ]
        },
        {
            path: '/zones',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/zones/:id/details',
                    component: zoneDetails,
                    name: 'zoneDetails',
                    icon: 'fa fa-car',
                    props: true,
                    meta: {title: 'Зоны'}
                }
            ]
        },
        {
            path: '/device',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [{
                hidden: true,
                path: '/device/:id/details',
                component: deviceDetails,
                name: 'deviceDetails',
                icon: 'icon-dashboard',
                meta: {title: 'Детали устройства'}
            }]
        },
        {
            path: '/abonements',
            component: Layout,
            hidden: false,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/abonements',
                    component: abonements,
                    name: 'abonements',
                    icon: 'fa fa-id-card',
                    props: true,
                    meta: {title: 'Абонементы'}
                }]
        },
        {
            path: '/parkingCards',
            component: Layout,
            hidden: false,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/parkingCards',
                    component: parkingCards,
                    name: 'parkingCards',
                    icon: 'fa fa-clipboard',
                    props: true,
                    meta: {title: 'Карты на парковке'}
                }]
        },
        {
            path: '/control',
            component: Layout,
            hidden: true,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/control',
                    component: control,
                    name: 'control',
                    icon: 'fa fa-check-square',
                    props: true,
                    meta: {title: 'Контроль проездов'}
                }]
        },
        {
            path: '',
            component: Layout,
            hidden: false,
            noDropdown: true,
            props: true,
            children: [
                {
                    path: '/config',
                    component: config,
                    name: 'config',
                    icon: 'icon-settings-work-tool',
                    props: true,
                    meta: {title: 'Конфигурация'}
                }]
        }
    ]

    routes = [...routes, ...routesAdmin]
}

export default routes
